<header *ngIf="current$ | async as current" class="w-full shrink-0 border-b border-gray-200 bg-white">
  <div class="max-w-6xl mx-auto px-6 py-3 grid grid-cols-3 items-center gap-4">
    <div class="flex items-center gap-3 min-w-0">
      <img *ngIf="current.coatOfArms" [src]="current.coatOfArms" alt="" class="h-16 w-auto shrink-0" />
      <div class="leading-tight min-w-0">
        <div class="text-xs uppercase tracking-wide text-gray-600">{{ 'appointment.booking.header.comuneDi' | translate }}</div>
        <div class="text-xl font-bold text-brand-700 truncate">{{ current.label || current.fallbackLabel }}</div>
      </div>
    </div>
    <div class="text-center text-sm md:text-base font-semibold text-brand-700">
      {{ 'appointment.booking.header.portal' | translate }}
    </div>
    <div class="flex justify-end">
      <img *ngIf="current.auslLogo" [src]="current.auslLogo" alt="" class="h-16 w-auto" />
    </div>
  </div>
</header>
